export default __webpack_public_path__ + "static/media/breathe5.519f681b.gif";